import ExperienceWrapper from 'components/experience-wrapper';
import { useCommon } from 'contexts/common';
import PromoBarSmallComponent from 'modules/content-cms/sections/promo-bar-small/promo-bar-small';
import React, { memo } from 'react';

const PromoBarSmall: React.FC = () => {
  const { globalData } = useCommon();

  if (globalData && globalData.fields.promoBarSmall) {
    return (
      <ExperienceWrapper
        component={PromoBarSmallComponent}
        entry={globalData.fields.promoBarSmall}
      />
    );
  }

  return null;
};

export default memo(PromoBarSmall);
